export default __webpack_public_path__ + "assets/fonts/72595b67365750a5ef69d84d6afc3f80.woff";